import Vue from 'vue';
import store from 'store';

import 'sky-form-editor';
import 'sky-reveal';
import 'sky-crop';
import 'sky-svg';

import 'bo-list';

import VueNl2br from 'plugins/nl2br';

Vue.use(VueNl2br);

new Vue({
	el: '[sky-app]',
	store,
});



// WEBPACK FOOTER //
// ./scripts/app.js